<template>
  <app-layout>
    <dashboard-layout>
      <template slot="footer-row">
        <v-container class="p-1">
          <v-layout row wrap>
            <v-flex md12>
              <v-breadcrumbs :items="breadItems">
                <template v-slot:item="props">
                  <router-link
                    class="breadcrumb-item"
                    :class="{ 'breadcrumb-bold': props.item.text === 'Club Rebelde' }"
                    :to="props.item.href"
                  >
                    {{ props.item.text }}
                  </router-link>
                </template>
                <template v-slot:divider>
                  <v-icon>chevron_right</v-icon>
                </template>
              </v-breadcrumbs>
            </v-flex>
            <v-flex md12 v-if="!partnerLoaded">
              <v-progress-linear :indeterminate="true"></v-progress-linear>
            </v-flex>
            <v-flex md12 v-else>
              <v-card class="pa-4">
                <v-card-title primary-title>
                  <v-container class="pa-0">
                    <v-flex md12>
                      <v-img :src="partner.logo_url" height="70" contain position="left"></v-img>
                      <h2 class="mt-3">
                        {{ partner.subheader }}
                      </h2>
                    </v-flex>
                    <v-flex md12>
                      <hr class="mt-3 mb-3" style="border: solid 1px #FFB01E; width: 80%" />
                    </v-flex>
                    <v-flex md8 sm10 xs12 class="club-text" v-html="partner.body"></v-flex>
                    <v-flex md12>
                      <v-btn
                        color="#FFB01E"
                        class="white--text"
                        :href="partner.link_url"
                        target="_blank"
                      >
                        <!-- <v-icon class="mr-3" right dark>cloud_download</v-icon> -->
                        {{ partner.link_text }}
                      </v-btn>
                    </v-flex>
                    <v-flex md12>
                      <hr class="mt-3 mb-3" style="border: solid 1px #E6E6E6; width: 80%" />
                    </v-flex>
                    <v-flex md8 sm10 xs12 class="club-text" v-html="partner.footer"></v-flex>
                  </v-container>
                </v-card-title>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
      <template slot="sidebar">
        <v-flex md12>
          <my-consultant-conversation></my-consultant-conversation>
        </v-flex>
        <v-flex md12 pt-3>
          <calendar-events></calendar-events>
        </v-flex>
      </template>
    </dashboard-layout>
    <router-view></router-view>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import DashboardLayout from '@/views/layouts/DashboardLayout.vue';
import MyConsultantConversation from '@/modules/myconsultant/components/threads/MyConsultantConversation.vue';
import CalendarEvents from '@/modules/calendar/components/CalendarEvents.vue';
import apiCtrl from '@/services/api/abstract/abstract-api.js';

export default {
  components: {
    AppLayout,
    CalendarEvents,
    MyConsultantConversation,
    DashboardLayout,
  },

  data: () => ({
    partnerLoaded: false,
    partner: [],
  }),
  computed: {
    breadItems() {
      return [
        {
          text: 'Club Rebelde',
          disabled: false,
          href: 'main',
        },
        {
          text: this.$route.meta.title,
          disabled: true,
          href: this.$route.meta.alias,
        },
      ];
    },
  },
  mounted() {
    this.getPartner();
  },

  methods: {
    markDocNotificationsAsReaded(category) {
      const body = {
        category: category,
      };
      apiCtrl.post('/document-notification/mark-as-readed', body).then(res => {
        console.log(res);
      });
    },
    getPartner() {
      this.partnerLoaded = false;
      const config = {
        params: {},
      };
      apiCtrl
        .get(`/club-space/${this.$route.meta.alias}`, config)
        .then(res => {
          this.partner = res.data.data;
          this.partnerLoaded = true;
        })
        .catch(() => {
          this.partnerLoaded = false;
          // this.showSnackMessage(
          //   'error',
          //   'Se ha producido un error al cargar las obligaciones fiscales',
          // );
        });
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.getPartner();
    },
  },
};
</script>
<style scoped>
.club-title {
  font-size: 2rem;
}
.club-text {
  font-size: 1.2rem;
}
.breadcrumb-item {
  text-decoration: none;
  font-size: 1.2rem;
}
.breadcrumb-bold {
  font-weight: bold;
}
</style>
